import routes from './routes';
import routeTypes from './routeTypes';
import layouts from './layouts';
import {
	NotFoundPage,
	LoginPage,
	ForgetPasswordPage,
	ResetPasswordPage,
	SignupPage,
	ServicesPage,
	CashbackListPage,
	CashbackAddPage,
	CashbackEditPage,
	LandingOffCb,
	LandingCoreService,
	CouponRedemptionQrCodePage,
	CouponRedemptionOtherWaysPage,
	CouponRedemptionCancellationPage,
	CoreServicesListPage,
	CoreServicesCreatePage,
	CoreServicesEditPage,
	MorePage,
	BusinessFormPage,
	CashbackSettingPage,
	ReportsPage,
	OffcbReports,
	CoreReports,
	HomePage,
	GeuestLanding,
	TicketsPage,
	TicketsCreatePage,
	PaymentRequestPage,
	CommentsPage,
	ProfileSettingPage,
	FaqPage,
	OnBoardingPage,
	QuestionsAndAnswersPage,
	NotificationsPage,
	AdvancedSearchPage,
	LoginBusinessLinePage,
	ContractPage,
	TutorialVideos,
	OfflineVendorsPage,
	SignupBusinessPage,
	SignupSuccessful,
	WalletTransaction,
	FactorAmount,
	StatusTransaction,
	ScanBarcode,
	ManualBarcode,
	TakhfifanPayContractPage,
	OfflineContracts,
	PriceListPage,
} from 'Pages';

const routers = [
	{
		id: routes[404],
		path: routes[404],
		element: NotFoundPage,
	},
	{
		id: routes.guest,
		path: routes.guest,
		element: GeuestLanding,
	},
	{
		id: routes.gtm,
		path: routes.gtm,
		element: GeuestLanding,
	},
	{
		id: routes.onboarding,
		path: routes.onboarding,
		element: OnBoardingPage,
	},
	{
		id: routes.selectBusinessLine,
		path: routes.selectBusinessLine,
		element: LoginBusinessLinePage,
	},
	{
		id: routes.transactionStatus,
		path: routes.transactionStatus,
		element: StatusTransaction,
	},
	{
		id: layouts.authentication.name,
		type: routeTypes.layout,
		element: layouts.authentication.element,
		pages: [
			{
				id: routes.login,
				path: routes.login,
				element: LoginPage,
				props: { title: 'ورود به کسب و کار تخفیفانی' },
			},
			{
				id: routes.offlineContracts,
				path: routes.offlineContracts,
				element: OfflineContracts,
				props: {
					title: ' ',
				},
			},
			{
				id: routes.loginRedirect,
				path: routes.loginRedirect,
				element: LoginPage,
				props: { title: 'ورود به کسب و کار تخفیفانی' },
			},
			{
				id: routes.forgetPasword,
				path: routes.forgetPasword,
				element: ForgetPasswordPage,
				props: { title: 'فراموشی رمز عبور' },
			},
			{
				id: routes.resetPassword,
				path: routes.resetPassword,
				element: ResetPasswordPage,
				props: { title: 'بازیابی رمز عبور' },
			},
			{
				id: routes.signup,
				path: routes.signup,
				element: SignupPage,
				props: { title: 'ثبت نام کسب و کار تخفیفانی' },
			},
		],
	},
	{
		id: layouts.simple.name,
		type: routeTypes.layout,
		element: layouts.simple.element,
		pages: [
			{
				id: routes.offlineVendors,
				path: routes.offlineVendors,
				element: OfflineVendorsPage,
			},
			{
				id: routes.signupSuccessful,
				path: routes.signupSuccessful,
				element: SignupSuccessful,
				props: { title: 'ثبت نام کسب و کار تخفیفانی' },
			},
			{
				id: routes.signupBusiness,
				path: routes.signupBusiness,
				element: SignupBusinessPage,
				props: { title: 'ثبت نام کسب و کار تخفیفانی' },
			},
		],
	},
	{
		id: layouts.withoutHeader.name,
		type: routeTypes.layout,
		element: layouts.withoutHeader.element,
		pages: [
			{
				id: routes.core,
				path: routes.core,
				element: CoreReports,
			},
			{
				id: routes.offcb,
				path: routes.offcb,
				element: OffcbReports,
			},
		],
	},
	{
		id: layouts.default.name,
		type: routeTypes.layout,
		element: layouts.default.element,
		pages: [
			{
				id: routes.services,
				path: routes.services,
				element: ServicesPage,
			},
			{
				id: routes.dashboard,
				path: routes.dashboard,
				element: HomePage,
			},
			{
				id: routes.home,
				path: routes.home,
				element: HomePage,
			},
			{
				id: routes.more,
				path: routes.more,
				element: MorePage,
			},
			{
				id: routes.reports,
				path: routes.reports,
				element: ReportsPage,
			},
		],
	},
	{
		id: layouts.internal.name,
		type: routeTypes.layout,
		element: layouts.internal.element,
		pages: [
			{
				id: routes.tutorial,
				path: routes.tutorial,
				element: TutorialVideos,
				props: {
					title: 'فیلم‌های آموزشی',
					back: routes.dashboard,
					headerIcons: ['support', 'onboarding'],
					isHeaderSticky: false,
				},
			},
			{
				id: routes.contract,
				path: routes.contract,
				element: ContractPage,
				props: {
					title: 'قراردادها',
					back: routes.more,
					headerIcons: ['support', 'onboarding'],
					isHeaderSticky: false,
				},
			},
			{
				id: routes.takhfifanPayContract,
				path: routes.takhfifanPayContract,
				element: TakhfifanPayContractPage,
				props: {
					title: 'قرارداد تخفیفان‌پی',
					back: routes.more,
					headerIcons: ['support'],
					isHeaderSticky: false,
				},
			},
			{
				id: routes.profileSetting,
				path: routes.profileSetting,
				element: ProfileSettingPage,
				props: {
					title: 'تنظیمات حساب کاربری',
					back: routes.more,
					// headerIcons: ['support', 'onboarding'],
					isHeaderSticky: true,
				},
			},
			{
				id: routes.coreServices,
				path: routes.coreServices,
				element: CoreServicesListPage,
				props: {
					title: 'آگهی‌های تخفیف',
					back: routes.services,
					headerIcons: ['support', 'onboarding', 'notification'],
					isHeaderSticky: true,
				},
			},
			{
				id: routes.coreServicesCreate,
				path: routes.coreServicesCreate,
				element: CoreServicesCreatePage,
				props: {
					title: 'افزودن آگهی تخفیف',
					headerIcons: ['support'],
					isHeaderSticky: true,
				},
			},
			{
				id: routes.coreServicesEdit,
				path: routes.coreServicesEdit,
				element: CoreServicesEditPage,
				props: {
					title: 'ویرایش اطلاعات  آگهی تخفیف',
					back: routes.coreServices,
					isHeaderSticky: true,
				},
			},
			{
				id: routes.landingOffCb,
				path: routes.landingOffCb,
				element: LandingOffCb,
				props: { title: 'آگهی بازگشت وجه', isHeaderSticky: true },
			},
			{
				id: routes.landingCoreService,
				path: routes.landingCoreService,
				element: LandingCoreService,
				props: { title: 'سرویس فروش  آگهی تخفیف', isHeaderSticky: true },
			},
			{
				id: routes.cashbackedit,
				path: routes.cashbackedit,
				element: CashbackEditPage,
				props: { title: 'ویرایش اطلاعات دستگاه', isHeaderSticky: true },
			},
			{
				id: routes.couponRedemptionOtherWay,
				path: routes.couponRedemptionOtherWay,
				element: CouponRedemptionOtherWaysPage,
				props: {
					title: 'مدیریت کوپن‌ها',
					isHeaderSticky: true,
					back: routes.dashboard,
				},
			},
			{
				id: routes.couponRedemptionCancellation,
				path: routes.couponRedemptionCancellation,
				element: CouponRedemptionCancellationPage,
				props: {
					title: 'ابطال کوپن',
					isHeaderSticky: true,
					back: routes.dashboard,
					headerIcons: ['qrCode'],
				},
			},
			{
				id: routes.cashbackadd,
				path: routes.cashbackadd,
				element: CashbackAddPage,
				props: {
					title: 'افزودن دستگاه پوز بانکی',
					headerIcons: ['onboarding'],
					isHeaderSticky: true,
				},
			},
			{
				id: routes.cashbacklist,
				path: routes.cashbacklist,
				element: CashbackListPage,
				props: {
					title: 'آگهی‌های بازگشت وجه',
					back: routes.services,
					headerIcons: ['support', 'onboarding', 'notification'],
					isHeaderSticky: true,
				},
			},
			{
				id: routes.cashbacksetting,
				path: routes.cashbacksetting,
				element: CashbackSettingPage,
				props: { title: 'تنظیمات بازگشت وجه', isHeaderSticky: true },
			},
			{
				id: routes.couponRedemptionQr,
				path: routes.couponRedemptionQr,
				element: CouponRedemptionQrCodePage,
				props: {
					title: 'اسکن کوپن',
					back: '',
					isHeaderSticky: true,
					headerIcons: ['couponCancellation'],
				},
			},
			{
				id: routes.editBusiness,
				path: routes.editBusiness,
				element: BusinessFormPage,
				props: {
					title: 'تکمیل اطلاعات کسب‌وکار',
					isHeaderSticky: true,
					back: routes.more,
					headerIcons: ['onboarding'],
				},
			},
			{
				id: routes.ticketsList,
				path: routes.ticketsList,
				element: TicketsPage,
				props: {
					title: 'تیکت‌های پشتیبانی',
					isHeaderSticky: true,
					back: routes.more,
					headerIcons: ['support', 'onboarding'],
				},
			},
			{
				id: routes.ticketsCreate,
				path: routes.ticketsCreate,
				element: TicketsCreatePage,
				props: {
					title: 'افزودن تیکت جدید',
					headerIcons: ['support', 'onboarding'],
					isHeaderSticky: true,
				},
			},
			{
				id: routes.paymentRequest,
				path: routes.paymentRequest,
				element: PaymentRequestPage,
				props: {
					title: 'درخواست تسویه',
					isHeaderSticky: true,
					headerIcons: ['support', 'onboarding'],
				},
			},
			{
				id: routes.comments,
				path: routes.comments,
				element: CommentsPage,
				props: {
					title: 'نظرات کاربران',
					isHeaderSticky: true,
					headerIcons: ['support', 'onboarding'],
				},
			},
			{
				id: routes.faq,
				path: routes.faq,
				element: FaqPage,
				props: {
					title: 'پرسش‌های متداول',
					isHeaderSticky: true,
					back: routes.more,
				},
			},
			{
				id: routes.questionsAndAnswers,
				path: routes.questionsAndAnswers,
				element: QuestionsAndAnswersPage,
				props: {
					title: 'پرسش و پاسخ',
					isHeaderSticky: true,
					back: routes.more,
					headerIcons: ['support', 'onboarding'],
				},
			},
			{
				id: routes.notifications,
				path: routes.notifications,
				element: NotificationsPage,
				props: {
					title: 'اعلان‌ها',
					isHeaderSticky: true,
					back: routes.dashboard,
				},
			},
			{
				id: routes.advancedSearch,
				path: routes.advancedSearch,
				element: AdvancedSearchPage,
				props: {
					title: 'جستجوی پیشرفته',
					headerIcons: ['support', 'onboarding', 'notification'],
					isHeaderSticky: true,
				},
			},
			{
				id: routes.priceList,
				path: routes.priceList,
				element: PriceListPage,
				props: {
					title: 'لیست قیمت',
					isHeaderSticky: true,
					back: routes.dashboard,
					headerIcons: ['priceListHelp', 'support'],
				},
			},
			{
				id: routes.walletTransaction,
				path: routes.walletTransaction,
				element: WalletTransaction,
				props: {
					title: 'تراکنش‌ها از کیف پول',
					isHeaderSticky: true,
					back: routes.dashboard,
				},
			},
			{
				id: routes.factorAmount,
				path: routes.factorAmount,
				element: FactorAmount,
				props: {
					title: 'مبلغ فاکتور',
					isHeaderSticky: true,
					back: routes.dashboard,
				},
			},
			{
				id: routes.manualBarcode,
				path: routes.manualBarcode,
				element: ManualBarcode,
				props: {
					title: 'وارد کردن دستی بارکد',
					isHeaderSticky: true,
					back: routes.factorAmount,
					headerIcons: ['manualBarcode'],
				},
			},
			{
				id: routes.scanBarcode,
				path: routes.scanBarcode,
				element: ScanBarcode,
				props: {
					title: 'اسکن بارکد',
					isHeaderSticky: true,
					back: routes.factorAmount,
					headerIcons: ['barcode'],
				},
			},
		],
	},
];

export default routers;
